module.exports = __webpack_public_path__ + "static/media/emoji-neutral.cd025c9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/emoji-neutral.svg
// module id = 455
// module chunks = 0